module.exports = __webpack_public_path__ + "img/Calumpit.b05c0775.png";